import MkuTabPane from '../tabs/src/tab-pane';

MkuTabPane.install = function (Vue) {
  Vue.component(MkuTabPane.name, MkuTabPane);
};

export default MkuTabPane;
